var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-min-h-screen tw-w-full tw-bg-[#121317]"},[_c('FormLogin')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }